import { render } from "./ReworkPanel.vue?vue&type=template&id=5af072d6&scoped=true"
import script from "./ReworkPanel.vue?vue&type=script&lang=js"
export * from "./ReworkPanel.vue?vue&type=script&lang=js"

import "./ReworkPanel.vue?vue&type=style&index=0&id=5af072d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af072d6"]])

export default __exports__